import React, { Component } from "react";
import ApexCharts from "apexcharts";

export default class EmailSent extends Component {
    state = { chart: null };

    componentDidMount() {
        this.load();
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        if (this.state.chart) {
            this.state.chart.destroy();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value || this.props.percent !== prevProps.percent) {
            if (this.state.chart) {
                this.state.chart.destroy();
            }
            this.load();
        }
    }

    handleResize = () => {
        if (this.state.chart) {
            this.state.chart.destroy();
        }
        this.load();
    };

    load = () => {
        let value = this.props.value ? this.props.value : 0;
        const chartHeight = 200;
        const chartWidth = 150;

        let options = {
            series: [this.props.percent],
            chart: {
                height: chartHeight,
                width: chartWidth,
                type: "radialBar",
                offsetY: -10
            },
            colors: ["#287150"],
            tooltip: {
                enabled: true,
                style: {
                    background: "white",
                    fontSize: "12px"
                },
                y: {
                    formatter: (val) => val + "%"
                }
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: "60%"
                    },
                    dataLabels: {
                        name: {
                            show: false   // 👈 this removes "Email Sent"
                        },
                        value: {
                            offsetY: 13,
                            fontSize: "22px",
                            formatter: function () {
                                return value;
                            }
                        }
                    }
                }
            },
            labels: ["Email Sent"]
        };

        const chart = new ApexCharts(
            document.querySelector("#emailsend"),
            options
        );

        chart.render();
        this.setState({ chart });
    };

    render() {
        return <div id="emailsend" className="chart-container"></div>;
    }
}
